import { Typography, Box } from '@mui/material'
import clsx from 'clsx'
import React, { memo } from 'react'
import { FormattedMessage } from 'react-intl'
import sx from './styles'

const Disclaimer = ({
  text,
  hightlightText,
  formattedText = false,
  withBackgroundGrey = true,
  sx: sxProp,
  variant = 'body2',
  component = 'p',
  content,
}) => {
  return (
    <Box
      sx={{ ...sx.root, ...sxProp }}
      className={clsx({ backgroundGray: withBackgroundGrey })}
    >
      <Typography
        variant={variant}
        component={component}
      >
        {hightlightText && (
          <Typography
            variant="strong"
            component="span"
            mr={0.3}
          >
            <FormattedMessage id={hightlightText} />
          </Typography>
        )}
        {formattedText
          ? (<FormattedMessage id={text} />)
          : (text)}

      </Typography>

      {content}

    </Box>
  )
}

export default memo(Disclaimer)
